import $dayjs from '@/services/date'
import { DurationUnits } from '@/shared/constants/date/DurationUnits.js'
import DateFormatToken from '@/shared/constants/date/DateFormatToken'
import { orderBy } from 'lodash'
import TimesheetsWeekGroupingListItem from '@/models/timesheets/timesheetsWeekGroupingListItem'

export const getWeekRangeStringFromTimesheet = (timesheet, $i18n) => {
  const localeDate = $dayjs(timesheet.startTimeLocal).locale(
    $i18n.locale.toLowerCase()
  )

  const startDay = localeDate
    .startOf(DurationUnits.WEEK)
    .format(DateFormatToken.dddL)
  const endDay = localeDate
    .endOf(DurationUnits.WEEK)
    .format(DateFormatToken.dddL)

  return `${startDay} - ${endDay}`
}

export const groupCandidateTimesheets = (timesheets) => {
  const mappedList = []
  for (const [key, value] of Object.entries(timesheets)) {
    if (!timesheets || timesheets.length === 0) return []

    const groupedByCandidate = linqGroupBy(
      value,
      (timesheet) => timesheet.candidateId
    )

    // We're using the startTimeLocal of the first candidate's timesheets to sort
    // the grouped list of timesheets by ascending order.
    const keyOfFirstElementInList = Object.keys(groupedByCandidate)[0]
    const firstBookingDate =
      groupedByCandidate[keyOfFirstElementInList][0]?.startTimeLocal

    mappedList.push(
      new TimesheetsWeekGroupingListItem({
        title: key,
        sortDate: firstBookingDate,
        timesheets: groupedByCandidate,
      })
    )
  }

  const orderedList = orderBy(mappedList, 'sortDate', 'asc')
  return orderedList
}

/**
 * Mimicks the groupBy functionality of LINQ.
 * Sourced from https://stackoverflow.com/a/68896039 @ 2021-09-09 10:56 AM
 * @param {Array} source
 * @param {Function} keySelector
 * @returns
 */
const linqGroupBy = (source, keySelector) => {
  if (source == null) throw new Error('ArgumentNullException: Source')
  if (keySelector == null) throw new Error('ArgumentNullException: keySelector')
  const dict = {}
  for (let i = 0; i < source.length; ++i) {
    const key = keySelector(source[i]).toString()
    if (!Object.prototype.hasOwnProperty.call(dict, key)) {
      dict[key] = []
    }
    dict[key].push(source[i])
  }
  return dict
}
